export const catalog_kharkov = {
    name: 'Харків',
}